import React, { Component } from 'react';

export default class JwPlayer extends Component {

  get id() {
    this._id = this._id || 'id' + Math.floor(Math.random() * 100000000);
    return this._id;
  }

  get media() {
    return this.props.media;
  }

  get width() {
    return this.props.width || 480;
  }

  get height() {
    return this.props.height || (this.type === 'video' ? 270 : 40);
  }

  componentDidMount() {
    this.player = jwplayer(this.id);
    this.player.setup({
      file: this.media,
      width: this.width,
      height: this.height
    });
  }

  render() {
    return (
      <div id={this.id}></div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/common/jw-player.js